import React from "react";

export default function Banner() {
  return (
    <section className="banner" aria-labelledby="banner-heading">
      <div className="banner__bg">
        <img src="/images/banner/1.png" alt="Proxium banner showing science and care concept" />
      </div>
      <div className="auto__container">
        <div className="banner__inner">
          <div className="banner__inner-title">
            <h2 id="banner-heading">"At the Forefront of Combining <br /> Science and Care"</h2>
          </div>
        </div>
      </div>
    </section>
  );
}
